import home from './home'
import management from './management'
import usermanagement from './usermanagement'
import clientManagement from './clientManagement'
import about from './about'
import usercenter from './usercenter'

export default {
    ...home,
    ...management,
    ...usermanagement,
    ...clientManagement,
    ...about,
    ...usercenter
}